import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "step" }
const _hoisted_2 = { class: "step-header" }
const _hoisted_3 = { class: "step-icon" }
const _hoisted_4 = { class: "form-field" }
const _hoisted_5 = { class: "working-days-selection" }
const _hoisted_6 = { class: "form-field" }

import { reactive, ref } from "vue";
import AppTextField from "@/shared/components/ui/AppTextField.vue";

type DayKey = "mon" | "tue" | "wed" | "thu" | "fri" | "sat" | "sun";


export default /*@__PURE__*/_defineComponent({
  __name: 'ScheduleSetupStep',
  props: {
    current_step: {},
    errors: {},
    profileInfo: {}
  },
  setup(__props: any, { expose: __expose }) {



const days: { key: DayKey; label: string; shortLabel: string }[] = [
  { key: "mon", label: "Monday", shortLabel: "Mon" },
  { key: "tue", label: "Tuesday", shortLabel: "Tue" },
  { key: "wed", label: "Wednesday", shortLabel: "Wed" },
  { key: "thu", label: "Thursday", shortLabel: "Thu" },
  { key: "fri", label: "Friday", shortLabel: "Fri" },
  { key: "sat", label: "Saturday", shortLabel: "Sat" },
  { key: "sun", label: "Sunday", shortLabel: "Sun" },
];

const selectedDays = reactive<DayKey[]>(["mon", "tue", "wed", "thu", "fri"]);
const startTime = ref("09:00");
const endTime = ref("17:00");

function toggleDay(dayKey: DayKey) {
  const index = selectedDays.indexOf(dayKey);
  if (index > -1) {
    selectedDays.splice(index, 1);
  } else {
    selectedDays.push(dayKey);
  }
}

function getValues() {
  const schedule: Record<DayKey, { enabled: boolean; open: string; close: string }> = {} as any;
  days.forEach(day => {
    schedule[day.key] = {
      enabled: selectedDays.includes(day.key),
      open: startTime.value,
      close: endTime.value,
    };
  });
  return { schedule };
}

__expose({ getValues });

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_v_icon, {
          size: "24",
          color: "#e8612f"
        }, {
          default: _withCtx(() => [...(_cache[2] || (_cache[2] = [
            _createTextVNode("mdi-calendar-edit", -1)
          ]))]),
          _: 1
        })
      ]),
      _cache[3] || (_cache[3] = _createElementVNode("div", { class: "step-content" }, [
        _createElementVNode("h2", { class: "title" }, "Schedule Setup"),
        _createElementVNode("p", { class: "desc" }, " Define availability and working hours. ")
      ], -1))
    ]),
    _createElementVNode("div", _hoisted_4, [
      _cache[4] || (_cache[4] = _createElementVNode("div", { class: "label" }, [
        _createElementVNode("span", null, "Working Days")
      ], -1)),
      _createElementVNode("div", _hoisted_5, [
        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(days, (day) => {
          return _createVNode(_component_v_btn, {
            key: day.key,
            color: selectedDays.includes(day.key) ? 'primary' : '',
            variant: selectedDays.includes(day.key) ? 'flat' : 'outlined',
            onClick: ($event: any) => (toggleDay(day.key))
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(day.shortLabel), 1)
            ]),
            _: 2
          }, 1032, ["color", "variant", "onClick"])
        }), 64))
      ])
    ]),
    _createElementVNode("div", _hoisted_6, [
      _cache[5] || (_cache[5] = _createElementVNode("div", { class: "label" }, [
        _createElementVNode("span", null, "Working Hours")
      ], -1)),
      _createVNode(_component_v_row, null, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createVNode(AppTextField, {
                modelValue: startTime.value,
                "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((startTime).value = $event)),
                type: "time",
                label: "Start Time",
                "label-icon": "mdi-clock-time-four-outline"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, { cols: "6" }, {
            default: _withCtx(() => [
              _createVNode(AppTextField, {
                modelValue: endTime.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((endTime).value = $event)),
                type: "time",
                label: "End Time",
                "label-icon": "mdi-clock-time-eight-outline"
              }, null, 8, ["modelValue"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ])
  ]))
}
}

})